import React from 'react'

export default class IconsAlignRight extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                style={this.props.style}
            >
                <path d='M14 8H6' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
                <path
                    d='M13.9998 12H4.6665'
                    stroke={color}
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path d='M14 4H2' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
        )
    }
}
